import { motion } from "framer-motion";
import { BookOpen, Wallet, Ship, ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Trust } from "../components/home/Trust";
import { useLang } from "../i18n/LanguageContext";

const icons = [BookOpen, Wallet, Ship];

export default function Resources() {
  const { t } = useLang();
  return (
    <main data-testid="resources-page">
      <PageHero kicker={t.nav.resources} title={t.pages.resources.title} sub={t.pages.resources.sub} testId="resources-hero" />
      <section className="bg-white py-8 md:py-12">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {t.pages.resources.categories.map((c, i) => {
              const Icon = icons[i];
              return (
                <motion.div
                  key={i}
                  data-testid={`resource-cat-${i}`}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.1 }}
                  className="group rounded-2xl border border-black/[0.07] bg-white p-8 hover:shadow-xl hover:shadow-sinovar-navy/5 transition-shadow"
                >
                  <div className={`flex h-12 w-12 items-center justify-center rounded-xl ${i === 1 ? "bg-sinovar-red/10 text-sinovar-red" : "bg-sinovar-blue/10 text-sinovar-blue"}`}>
                    <Icon className="h-6 w-6" strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-5 font-display text-xl font-bold tracking-tight text-sinovar-navy">{c.t}</h3>
                  <p className="mt-2 text-[15px] text-sinovar-navy/60 leading-relaxed">{c.d}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-sinovar-navy/40">
                    {t.common.comingSoon} <ArrowRight className="h-4 w-4" />
                  </span>
                </motion.div>
              );
            })}
          </div>
          <p className="mt-10 max-w-2xl text-base text-sinovar-navy/60 leading-relaxed">{t.pages.resources.body}</p>
        </div>
      </section>
      <Trust />
    </main>
  );
}
